import * as React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { createTheme, ThemeProvider } from '@mui/material';

const customTheme = createTheme({
  palette: {
    primary: { main: '#06806B' },
    secondary: { main: '#5C5C5C' },
  },
});

export const DateTimePickerInput = ({
  closeFunction,
  defaultText,
  icon,
  initialValue,
  keyForElement,
  timeFormat,
}: {
  closeFunction: (date: Date | null) => void;
  defaultText?: string;
  icon?: React.ReactNode;
  initialValue?: string | Date | null;
  keyForElement?: string;
  timeFormat?: string;
}) => {
  const initialDate = initialValue ? new Date(initialValue) : null;
  const [selectedDate, setSelectedDate] = React.useState<Date | null>(initialDate);

  React.useEffect(() => {
    if (!initialValue) { return }

    setSelectedDate(new Date(initialValue))
  }, [initialValue])

  function handleAccept(newValue: Date | null) {
    closeFunction(newValue);
  }

  function handleBlur() {
    closeFunction(selectedDate);
  }

  function handleChange(newValue: Date | null) {
    setSelectedDate(newValue);
  }

  return (
    <ThemeProvider theme={customTheme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <div className="date-picker-container" key={keyForElement}>
          <div className="icon-and-datetime-picker">
            {icon}
            <DateTimePicker
              format={timeFormat || 'MM/d h:mm a'}
              onAccept={handleAccept}
              onChange={handleChange}
              slotProps={{
                popper: {
                  disablePortal: true,
                  modifiers: [
                    { name: 'flip', enabled: false },
                  ],
                },
                textField: {
                  'aria-label': defaultText || 'Select date & time',
                  inputProps: { onBlur: handleBlur },
                  placeholder: defaultText || 'Select date & time',
                },
              }}
              value={selectedDate}
            />
          </div>
        </div>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default DateTimePickerInput;
